import { io } from 'socket.io-client'

class SocketioService {
    socket;
    constructor() {}

    isEnabled() {
        return process.env.VUE_APP_ENABLE_WEBSOCKET === 'true'
    }

    setupSocketConnection() {
        if (!this.isEnabled()) {
            console.log('WebSocket is disabled via environment variable')
            return null
        }
        
        const token = process.env.VUE_APP_WSS_TOKEN || null
        this.socket = io(process.env.VUE_APP_SOCKET_URL, {
            extraHeaders: {
                token: token
            },
            query: {
                token: token
            }
        });
        
        return this.socket
    }
}

export default new SocketioService();